 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <div class="buttons" :style="{position: button_position}">
            <el-button @click="resetForm" v-if="role_id != 2">重置</el-button>
            <el-button @click="search" v-if="role_id != 2">筛选</el-button>
            <el-button :id="'hospitalAdd'" @click="addDoctor">新增</el-button>
        </div>


        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20" v-if="role_id != 2">
            <el-col :md="6" :lg="6" :xl="6" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">健康管理专家姓名：</span>
                <el-input v-model="user_name" placeholder="健康管理专家姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="5" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">手机号码：</span>
                <el-input v-model="mobile" placeholder="手机号码模糊搜素"/>
            </el-col>
            <el-col :md="9" :lg="9" :xl="10" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">更新时间：</span>
                <el-date-picker
                    v-model="search_expired_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                ></el-date-picker>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons" v-if="role_id != 2">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>

        <el-table :data="tableData" border style="width: 100%">
            <el-table-column width="50" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="region_name" label="区域" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="address" label="详细地址" align="center" label-class-name="label"></el-table-column>
            <el-table-column label="健康管理专家姓名" align="center" label-class-name="label">
                <template scope="scope">
                    {{scope.row.is_default == 1 ? scope.row.user_name+"(默认地址)":scope.row.user_name}}
                </template>
            </el-table-column>
            <el-table-column prop="mobile" label="健康管理专家电话" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="hospital_name" label="所属单位" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="department_name" label="科室" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column width="160" prop="update_date" label="更新时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="80" prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="130"
                prop="address"
                label="操作"
                align="center"
                label-class-name="label"
                v-slot="scope"
            >
                <el-button :id="'managerEdit'" @click="goEdit(scope.row)" type="text" size="small">
                    编辑
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopAddress(scope.row,2)"
                           v-if="scope.row.status_number==1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopAddress(scope.row,1)"
                           v-if="scope.row.status_number==2"
                           type="text"
                           size="small">启用
                </el-button>
                <el-button :id="'doctorEdit'" @click="deleteAddress(scope.row)"
                           type="text" size="mini">删除
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
            class="mg-20 ta-r"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 25, 50, 100]"
            :total="total"
            :page-size="perpage"
            :current-page="page"
            @current-change="changePage"
            @size-change="changeSite"
            v-if="is_pagination_show"
        ></el-pagination>
    </div>
</template>
<script>
import {check} from "@/utils/checkData";
import {export2Excel} from "@/utils/excel";
import {getUserInfos} from "@/utils/userInfos";
import {authUrlCheck, isMobile} from "@/api/order";

export default {
    data() {
        return {
            role_id: 0,
            page: 1,
            perpage: 10,
            total: 0,
            tableData: [],
            user_name: '',
            status: '',
            start_date: '',
            end_date: '',
            search_expired_date: '',
            mobile: '',
            allStatus: [
                {
                    id: 1,
                    name: '启用'
                },
                {
                    id: 2,
                    name: '停用'
                },
            ],
            is_submit: false,
            is_pagination_show: true,
            button_position: 'absolute',
        };
    },
    created() {
        if (isMobile()) {
            this.button_position = 'static'
        }
        // if (this.$route.params.hospital_department_id) {
        //     this.hospital_department_id = this.$route.params.hospital_department_id;
        // }
    },
    mounted() {
        let prev_page = localStorage.getItem('prev_page');
        if (prev_page == 'address_add' || prev_page == 'address_edit') {
            this.user_name = localStorage.getItem('address_list_user_name')
            this.status = parseInt(localStorage.getItem('address_list_status'))
            this.start_date = localStorage.getItem('address_list_start_date')
            this.end_date = localStorage.getItem('address_list_end_date')
            this.mobile = localStorage.getItem('address_list_mobile')
            this.page = parseInt(localStorage.getItem('page'))
            this.perpage = parseInt(localStorage.getItem('perpage'))
            this.search_expired_date = [this.start_date, this.end_date]
            if (this.user_name == 'undefined' || this.user_name == 'null') {
                this.user_name = ''
            }
            if (this.status == 'undefined' || this.status == 'null') {
                this.status = ''
            }
            if (this.start_date == 'undefined' || this.start_date == 'null') {
                this.start_date = ''
            }
            if (this.end_date == 'undefined' || this.end_date == 'null') {
                this.end_date = ''
            }
            if (this.mobile == 'undefined' || this.mobile == 'null') {
                this.mobile = ''
            }
            this.is_pagination_show = false
        }

        // 获取地址列表
        this.getList();
        let userInfo = getUserInfos()
        if (userInfo) {
            this.role_id = parseInt(userInfo.role_id)
        }
    },
    methods: {
        // 获取所有设备类型
        getList() {
            let params = {
                servername: 'Ruyi_AdminNewOperateServices',
                method: 'addressListing',
                pageinfo: {
                    page: this.page,
                    perpage: this.perpage,
                },
                params: {
                    user_name: this.user_name,
                    status: this.status,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    mobile: this.mobile,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                for (var i = 0; i < res.data.data.list.length; i++) {
                    // 序号
                    res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                    switch (res.data.data.list[i].status) {
                        case '1':
                            res.data.data.list[i].status = '启用';
                            res.data.data.list[i].status_number = 1;
                            break;
                        case '2':
                            res.data.data.list[i].status = '停用';
                            res.data.data.list[i].status_number = 2;
                            break;
                    }
                }
                this.tableData = res.data.data.list;
                this.total = res.data.data.page.count;
                this.is_submit = false;
                localStorage.setItem('address_list_user_name', this.user_name)
                localStorage.setItem('address_list_status', this.status)
                localStorage.setItem('address_list_start_date', this.start_date)
                localStorage.setItem('address_list_end_date', this.end_date)
                localStorage.setItem('address_list_mobile', this.mobile)
                localStorage.setItem('prev_page', 'address_list')
                localStorage.setItem('page', this.page)
                localStorage.setItem('perpage', this.perpage)
                this.is_pagination_show = true
            }).catch(()=>{
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },

        // 改变每页条数
        changeSite(index) {
            this.perpage = index;
            this.getList();
        },

        //更换页码
        changePage(index) {
            this.page = index;
            this.getList();
        },

        // 重置按钮
        resetForm() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.user_name = "";
            this.status = "";
            this.mobile = "";
            this.start_date = "";
            this.end_date = "";
            this.page = 1;
            this.search_expired_date = "";
            this.getList();
        },
        dateChange(e){
            if (!e) {
                this.search_expired_date = null
                this.start_date = ''
                this.end_date = ''
            }
        },
        // 搜索
        search() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            if (this.search_expired_date) {
                this.start_date = this.search_expired_date[0];
                this.end_date = this.search_expired_date[1];
            }

            this.page = 1;
            this.getList();
        },

        // 跳转添加页
        addDoctor() {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/manager/AddressAdd', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({name: "addressAdd", params: {}});
            return;
        },

        // 跳转编辑页
        goEdit(data) {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/manager/AddressEdit', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({
                name: "addressEdit",
                params: {
                    id: data.id,
                    address: data.address,
                    doctor_id: data.doctor_id,
                    is_default: parseInt(data.is_default),
                    distinct_id: data.distinct_id,
                    status: parseInt(data.status_number),
                    hosptial_name:data.hosptial_name,
                    department_name:data.department_name,
                }
            });
            return;
        },

        // 启用停用地址
        startStopAddress(data, status) {

            if (status == '1') {
                var message = '确定启用该地址吗？';
            }
            if (status == '2') {
                var message = '确定停用该地址吗？';
            }
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminNewOperateServices',
                    method: 'startStopAddress',
                    params: {
                        id: data.id,
                        status: data.status_number,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.$message.success('修改成功');


                    if (status == '1') {
                        data.status = '启用';
                        data.status_number = 1;
                    } else {
                        data.status = "停用";
                        data.status_number = 2;
                    }
                    //this.getList();
                });
            }).catch(() => {
            });
        },

        // 删除地址
        deleteAddress(data) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;

            this.$confirm('确定删除该地址吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminNewOperateServices',
                    method: 'deleteAddress',
                    params: {
                        id: data.id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    if (res.data.code != '0') {
                        this.$message({
                            type: "error",
                            message: res.data.msg,
                            duration: 1500,
                        });
                    } else {
                        this.$message({
                            type: "success",
                            message: '删除成功',
                            duration: 1500,
                        });
                    }
                    this.is_submit = false;
                    this.getList();
                }).finally(() => {
                    this.is_submit = false;
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },

        // 导出数据
        exportExcel() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let params = {
                servername: 'Ruyi_AdminNewOperateServices',
                method: 'exportAddress',
                params: {
                    user_name: this.user_name,
                    status: this.status,
                    mobile: this.mobile,
                    start_date: this.start_date,
                    end_date: this.end_date,
                },
            };

            let colums_list = [
                {title: "区域", key: "region_name"},
                {title: "详细地址", key: "address"},
                {title: "健康管理专家姓名", key: "user_name"},
                {title: "健康管理专家电话", key: "mobile"},
                {title: "所属单位", key: "hospital_nick_name"},
                {title: "科室", key: "department_name"},
                {title: "更新时间", key: "update_date"},
                {title: "状态", key: "status"},
            ];
            let export_data = [];
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }

                let res_data = res.data;
                if (parseInt(res_data.code) != 0) {
                    this.$message.error(res_data.msg);
                    this.is_submit = false;
                    return false;
                }


                for (var i = 0; i < res.data.data.length; i++) {
                    switch (res.data.data[i].status) {
                        case '1':
                            res.data.data[i].status = '启用';
                            break;
                        case '2':
                            res.data.data[i].status = '停用';
                            break;

                    }

                    let item = {
                        region_name: res.data.data[i].region_name,
                        user_name: res.data.data[i].user_name,
                        mobile: res.data.data[i].mobile,
                        address: res.data.data[i].address,
                        hospital_name: res.data.data[i].hospital_name,
                        department_name: res.data.data[i].department_name,
                        update_date: res.data.data[i].update_date,
                        status: res.data.data[i].status,
                    };
                    export_data.push(item);


                }


                export2Excel(colums_list, export_data, "健康管理专家地址数据");
                let _that = this
                setTimeout(function () {
                    _that.is_submit = false;
                }, 1500)
            }).finally(() => {
                this.is_submit = false;
            });
        }
    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.docker_buttons {
    float: right;
    margin: 30px 0px 8px 0px;

    .el-button {
        width: 150px;
        height: 32px;
        line-height: 7px;
    }
}
.el-col{
    margin-bottom: 10px;
    input{
        width: 100%;
    }
}
</style>
